<template>
  <div
    class="toast align-items-center"
    :class="classes + (localVisible ? ' show' : '')"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <div class="d-flex">
      <div class="toast-body">
        {{ toast.message }}
      </div>
      <button type="button" class="btn-close me-2 m-auto" @click="hide()"></button>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
export default {
  props: {
    classes: {
      type: String,
      default: 'bg-success text-white',
    },
    visible: {
      type: Boolean,
      default: true,
    },
    toast: {
      type: Object,
      default: () => {
        'Aktion erfolgreich ausgeführt.';
      },
    },
    delay: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const localVisible = ref(props.visible);

    const hide = () => {
      localVisible.value = false;
    };
    setTimeout(() => {
      hide();
    }, props.delay);
    return {
      localVisible,
      hide,
    };
  },
};
</script>
